import { apidel, apiget, apipost, apiput } from "../../api";
import { extractId } from "../models/_helpers";

export const types = {
  GET_CONTACTS: "GET_CONTACTS",
  ASK_NEW_CONTACT: "ASK_NEW_CONTACT",
  GET_CONTACT_BY_UUID: "GET_CONTACT_BY_UUID",
  GET_CONTACT_BY_UUID_D: "GET_CONTACT_BY_UUID_D",
  GET_CONTACT_BY_ID: "GET_CONTACT_BY_ID",
  UPDATE_CONTACT: "UPDATE_CONTACT",
  SEARCH_CONTACT: "SEARCH_CONTACT",
  SEARCH_CONTACT_WP: "SEARCH_CONTACT_WP",
  ADD_CONTACT: "ADD_CONTACT",
  ADD_CONTACT_WP: "ADD_CONTACT_WP",
  DELETE_CONTACT: "DELETE_CONTACT"
};

export const additions = {
  PARTNER: "partner",
  FONCTION: "fonction",
  DIPLOMA: "diploma",
  PROJECTS: "projects"
};

export const sortmodes = {
  BY_FIRST_NAME: "first_name",
  BY_FULL_NAME: "slug",
  BY_LAST_NAME: "last_name",
  BY_TRADE: "fonction.name",
  BY_EMPLOYER: "partner.name",
  BY_DIPLOMA: "diploma.name",
  BY_ID: "id"
};

export const actions = {
  [types.GET_CONTACTS]: token => async (_, appends) =>
    await apiget(`/contacts`, { appends }, token),
  [types.ASK_NEW_CONTACT]: token => async (_, name) =>
    await apipost("/contacts", name || {}, token),
  [types.GET_CONTACT_BY_UUID]: token => async (_, uuid) =>
    await apiget(`/contact/${uuid}`, {}, token),
  [types.GET_CONTACT_BY_ID]: token => async (_, id) =>
    await apiget(`/contact/${extractId(id)}`, {}, token),
  [types.GET_CONTACT_BY_UUID_D]: token => async (_, { uuid, appends = null }) =>
    await apiget(`/contact_d/${uuid}`, { appends }, token),
  [types.UPDATE_CONTACT]: token => async (_, contact) =>
    await apiput(`/contact/${contact.uuid}`, contact, token),
  [types.SEARCH_CONTACT]: token => async (_, { query }) =>
    await apiget(`/contacts/search/${query}`, {}, token),
  [types.SEARCH_CONTACT_WP]: token => async (_, { query, partner_id }) =>
    await apiget(
      `/contacts/search/${query}?partner_id=${partner_id}`,
      {},
      token
    ),
  [types.ADD_CONTACT]: token => async (_, { first_name, last_name }) =>
    await apipost(`/contacts`, { first_name, last_name }, token),
  [types.ADD_CONTACT_WP]: token => async (
    {},
    { first_name, last_name, partner_id }
  ) => await apipost(`/contacts`, { first_name, last_name, partner_id }, token),
  [types.DELETE_CONTACT]: token => async (_, identifier) =>
    await apidel(`/contact/${identifier}`, {}, token)
};
